'use client';

/**
 * Component to inject JSON-LD structured data into the page
 * @param {Object} props
 * @param {Object|Array} props.data - JSON-LD structured data (single object or array)
 */
export default function StructuredData({ data }) {
  const jsonLd = Array.isArray(data) ? data : [data];

  return (
    <>
      {jsonLd.map((item, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}
        />
      ))}
    </>
  );
}

